import {
    createActionCreator,
    createDeltaActionType,
    createSignalAction
} from '../../../setup-react';

// ===== Signals ============================================================ //

// Stats
export const FETCH_CAREER_AND_SEASON_STATS = createSignalAction(
    'stats/career-and-season-stats',
    'FETCH_CAREER_AND_SEASON_STATS'
);
    
// Nav
export const UPDATE_NAV_ITEM = createSignalAction(
    'stats/career-and-season-stats',
    'UPDATE_NAV_ITEM'
);

// Sort
export const UPDATE_SORT = createSignalAction(
    'stats/career-and-season-stats',
    'UPDATE_SORT'
);

// Benchmarking
export const UPDATE_BENCHMARKING = createSignalAction(
    'stats/career-and-season-stats',
    'UPDATE_BENCHMARKING'
);

// Data Type
export const UPDATE_DATA_TYPE = createSignalAction(
    'stats/career-and-season-stats',
    'UPDATE_DATA_TYPE'
);

// ===== Deltas ============================================================= //

// Stats
export const SET_CAREER_AND_SEASON_STATS = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_CAREER_AND_SEASON_STATS'
);
export const setCareerAndSeasonStats = createActionCreator(
    SET_CAREER_AND_SEASON_STATS
);

export const SET_CAREER_SEASONS_STATS = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_CAREER_SEASONS_STATS'
);
export const setCareerSeasonsStats = createActionCreator(
    SET_CAREER_SEASONS_STATS
);

export const SET_CAREER_AND_SEASON_STATS_REQUEST = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_CAREER_AND_SEASON_STATS_REQUEST'
);
export const setCareerAndSeasonStatsRequest = createActionCreator(
    SET_CAREER_AND_SEASON_STATS_REQUEST
);

export const REMOVE_CAREER_AND_SEASON_STATS_REQUEST = createDeltaActionType(
    'stats/career-and-season-stats',
    'REMOVE_CAREER_AND_SEASON_STATS_REQUEST'
);
export const removeCareerAndSeasonStatsRequest = createActionCreator(
    REMOVE_CAREER_AND_SEASON_STATS_REQUEST
);

// Nav
export const SET_NAV_ITEM = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_NAV_ITEM'
);
export const setNavItem = createActionCreator( SET_NAV_ITEM );

// Sort
export const SET_SORT = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_SORT'
);
export const setSort = createActionCreator( SET_SORT );

// Benchmarking
export const SET_BENCHMARKING = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_BENCHMARKING'
);
export const setBenchmarking = createActionCreator( SET_BENCHMARKING );

// Data Type
export const SET_DATA_TYPE = createDeltaActionType(
    'stats/career-and-season-stats',
    'SET_DATA_TYPE'
);
export const setDataType = createActionCreator( SET_DATA_TYPE );
